import * as pncGroups from './groups';
import * as pncVehicles from './vehicles';
import * as allPartNumberCode from './allPartNumberCode';
import * as pncInstance from './partNumberCodeInstance';

const reducers = {
  ...pncGroups,
  ...pncVehicles,
  ...allPartNumberCode,
  ...pncInstance,
};

export default reducers;
